export default __webpack_public_path__ + "static/media/AnimalsBlue_06.dd71b79b.png";